import createVanilla, { StoreApi } from "zustand/vanilla";
import create, { UseStore } from "zustand";
import { createStackedState } from "client/Misc/stackedState";

export type ResponsiveTitleStoreData = {
	customTitle: string | undefined;
	setCustomTitle(customTitle: string): (() => void);
};

const responsiveTitleStore: StoreApi<ResponsiveTitleStoreData> = createVanilla<ResponsiveTitleStoreData>(
	(set) => {
		return {
			customTitle: undefined,
			setCustomTitle: createStackedState<string>(
				(customTitle: string | undefined) => set({ customTitle })
			)
		};
	}
);

export const useResponsiveTitleStore: UseStore<ResponsiveTitleStoreData> = create(responsiveTitleStore);